export const API_SPECS = [
  { id: "products", name: "Products API", url: "/specs/products.yaml" },
  { id: "content", name: "Content API", url: "/specs/content.yaml" },
  { id: "pp_partner", name: "Post production partner API", url: "/specs/pp_partner.yaml" },
];
